import { init, priceDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { addSwiper, unbindOriginalSearch } from "./helpers"

import "./styles/index.css"

addSwiper();
unbindOriginalSearch('#Search-In-Modal'); // keep for removing native dropdowns from loading = lower GPU usage on mobile

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#Search-In-Modal",
    contentCssSelector: "#MainContent",
    // hitDecorators: [
    //     priceDecorator()
    // ],
    // contentCssSelector: ".nostoTargetSERP",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpPath: '/search',
    serpPathRedirect: false,
    serpQuery() {
        return {
            products: {
                // variationId: this.variationId(),
                fields: [
                    "productId", "url", 
                    "name", "tags1",
                    "imageUrl", "alternateImageUrls",
                    "brand", "availability", 
                    "price", "listPrice", "priceCurrencyCode",
                    "customFields.key", "customFields.value",
                    "skus.name", "skus.price", "skus.listPrice",
                    "skus.availability", "skus.id", "skus.imageUrl",
                    "skus.customFields.key", "skus.customFields.value"
                ],
                facets: ["*"],
                size: defaultConfig.serpSize,
                from: 0
            }
        }
    },
    autocompleteMinLength: 1,
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", 
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice", "priceCurrencyCode",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            // currency: this.variationId(),
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    // // Uncomment for Category Merchandising
    // categoryCssSelector: '.shopify-section[id$="__product-grid"]',
    //    categoryQuery() {
    //     return {
    //         name: 'serp',
    //         products: {
    //             categoryId: this.categoryId(),
    //             categoryPath: this.categoryPath(),
    //             size: defaultConfig.serpSize,
    //             from: 0,
    //         }
    //     }
    // },
}).then (() => {
    const inputEl = document.getElementById('Search-In-Modal');
    const closeSearchBtn = document.querySelector('.search-modal__close-button');
    if(inputEl && closeSearchBtn) {
        inputEl.addEventListener('keydown', (event) => {
            if(event.key === 'Enter' || event.key === 'Escape') {
                closeSearchBtn.click();
            }
        })
    };
})
